import React from 'react'
import { Button, Typography } from '@paintscout/ui'
import { useSherwinTrialOverDashboard } from '../useSherwinTrialOverDashboard'
import SherwinCouponCard from '../SherwinCouponCard'
import { useSherwinTrialOverDashboardDesktopLayoutStyles } from './useSherwinTrialOverDashboardDesktopLayoutStyles'

export default function SherwinTrialOverDashboardDesktop() {
  const classes = useSherwinTrialOverDashboardDesktopLayoutStyles()
  const { isAdmin, handleSelectPlan } = useSherwinTrialOverDashboard()

  return (
    <div className={classes.root}>
      <div className={classes.whiteBackground} />
      <div className={classes.leftSection}>
        <div className={classes.leftSectionContent}>
          <Typography className={classes.heading}>
            <span className={classes.headingFirstLine}>
              <span className={classes.headingHighlight}>Your PaintScout trial is over,</span>
            </span>
            <span className={classes.headingSecondLine}>but it doesn&lsquo;t have to end here.</span>
          </Typography>
          <Typography className={classes.description}>
            Sign up for a subscription to get your $100 Sherwin-Williams coupon.
          </Typography>
          {isAdmin && (
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleSelectPlan}
              className={classes.button}
            >
              Select Plan
            </Button>
          )}
        </div>
      </div>
      <div className={classes.rightSection}>
        <SherwinCouponCard />
      </div>
    </div>
  )
}
